
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><g clip-path='url(#clip0_17:18051)'><path d='M15.5002 15.38V8.62002L18.8802 12L15.5002 15.38ZM20.2902 12.71C20.6802 12.32 20.6802 11.69 20.2902 11.3L15.7002 6.71002C15.0802 6.08002 14.0002 6.52002 14.0002 7.41002V16.58C14.0002 17.47 15.0802 17.92 15.7102 17.29L20.2902 12.71ZM10.0002 16.59V7.41002C10.0002 6.52002 8.92021 6.07002 8.29021 6.70002L3.70021 11.29C3.31021 11.68 3.31021 12.31 3.70021 12.7L8.29021 17.29C8.92021 17.92 10.0002 17.48 10.0002 16.59Z' fill='#323232'/></g><defs><clipPath id='clip0_17:18051'><rect width='24' height='24' fill='white'/></clipPath></defs></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-switch-right`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconSwitchRight

    ```js
    <b-new-b-icon-switch-right />
    ```
</docs>


